import axios, { AxiosHeaders } from 'axios';
import { REQUEST_TIMEOUT } from '../constants/general';
import {
  generateXB3TraceID, getChannelID, getHost, getTmxId, isSsr
} from '../utils/general';
import { getAuthorizationToken } from '../utils/user';

const baseurl = getHost();
const channelId = getChannelID();
const Client = 'ocm_pd_experience_customer-account-orders-purchases';

const baseConfig = {
  baseURL: baseurl,
  headers: {
    channelId: String(channelId),
    Authorization: getAuthorizationToken(),
    'X-B3-TraceId': generateXB3TraceID(),
    Client,
  },
  timeout: REQUEST_TIMEOUT,
};

type AxiosInstance = ReturnType<typeof axios.create>;

const applyInterceptors = (instance: AxiosInstance): void => {
  // Resolve TMX session ID asynchronously per request so it is never stale
  instance.interceptors.request.use(async (requestConfig) => {
    const tmxId = isSsr ? '' : await getTmxId();
    // In axios 1.x, headers is always an AxiosHeaders instance by the time
    // request interceptors run, so .set() is safe here
    (requestConfig.headers as unknown as AxiosHeaders).set('TMXProfileID', tmxId);
    return requestConfig;
  });
};

const apiBase = axios.create(baseConfig);
const apiBaseWithBlob = axios.create({ ...baseConfig, responseType: 'blob' });

applyInterceptors(apiBase);
applyInterceptors(apiBaseWithBlob);

export { apiBase, apiBaseWithBlob };
